import '../../js/config.js';
import '../../js/initSideNav.js';
import '../../updates.js';
